export type TenantCode = "POSTBANK" | "DEUTSCHE_BANK_FINANZBERATUNG" | "DEUTSCHEBANKIMMOBILIEN";

export interface ITenantConfig {
	code: TenantCode;
	apiBaseUrl: string;
	ssoUrl: string;
	logoutUrl: string;
	moveMarketingRedirectUrl: string;
}

interface ITenantMatcher {
	tenant: TenantCode;
	indicators: string[];
}

const TENANT_MATCHERS: ITenantMatcher[] = [
	{
		tenant: "POSTBANK",
		indicators: [(process.env.REACT_APP_POSTBANK_URL_INDICATOR || "postbank").toLowerCase()],
	},
	{
		tenant: "DEUTSCHEBANKIMMOBILIEN",
		indicators: [
			(process.env.REACT_APP_DEUTSCHEBANKIMMOBILIEN_URL_INDICATOR || "deutschebankimmobilien").toLowerCase(),
		],
	},
	{
		tenant: "DEUTSCHE_BANK_FINANZBERATUNG",
		indicators: [(process.env.REACT_APP_DBF_URL_INDICATOR || "movevereinbarungsportal").toLowerCase()],
	},
];

const resolveTenant = (host: string): TenantCode => {
	const normalizedHost = host.toLowerCase();

	const matchedTenant = TENANT_MATCHERS.find(({ indicators }) =>
		indicators.some(indicator => normalizedHost.includes(indicator))
	);

	return matchedTenant?.tenant ?? "DEUTSCHE_BANK_FINANZBERATUNG";
};

const TENANT_CONFIGS: Record<TenantCode, ITenantConfig> = {
	POSTBANK: {
		code: "POSTBANK",
		apiBaseUrl: process.env.REACT_APP_API_BASE_URL_POSTBANK as string,
		ssoUrl: process.env.REACT_APP_SSO_URL_POSTBANK as string,
		logoutUrl: process.env.REACT_APP_LOGOUT_URL_POSTBANK as string,
		moveMarketingRedirectUrl: process.env.REACT_APP_MOVE_MARKETING_REDIRECT_POSTBANK as string,
	},
	DEUTSCHEBANKIMMOBILIEN: {
		code: "DEUTSCHEBANKIMMOBILIEN",
		apiBaseUrl: process.env.REACT_APP_API_BASE_URL_DEUTSCHEBANKIMMOBILIEN as string,
		ssoUrl: process.env.REACT_APP_SSO_URL_DEUTSCHEBANKIMMOBILIEN as string,
		logoutUrl: process.env.REACT_APP_LOGOUT_URL_DEUTSCHEBANKIMMOBILIEN as string,
		moveMarketingRedirectUrl: process.env.REACT_APP_MOVE_MARKETING_REDIRECT_DEUTSCHEBANKIMMOBILIEN as string,
	},
	DEUTSCHE_BANK_FINANZBERATUNG: {
		code: "DEUTSCHE_BANK_FINANZBERATUNG",
		apiBaseUrl: process.env.REACT_APP_API_BASE_URL as string,
		ssoUrl: process.env.REACT_APP_SSO_URL as string,
		logoutUrl: process.env.REACT_APP_LOGOUT_URL as string,
		moveMarketingRedirectUrl: process.env.REACT_APP_MOVE_MARKETING_REDIRECT as string,
	},
};

export const ACCESS_TOKEN = "accessToken";
export const LAST_UPDATE = "last_update";
export const MINUTES_30 = 1000 * 60 * 30;
export const WEB_BASE_URL = process.env.REACT_APP_WEB_BASE_URL as string;

export const CURRENT_TENANT = resolveTenant(window.location.host);
export const CURRENT_TENANT_CONFIG = TENANT_CONFIGS[CURRENT_TENANT];

export const API_BASE_URL = CURRENT_TENANT_CONFIG.apiBaseUrl;
export const SSO_URL = CURRENT_TENANT_CONFIG.ssoUrl;
export const LOGOUT_URL = CURRENT_TENANT_CONFIG.logoutUrl;
export const MOVE_MARKETING_REDIRECT_URL = CURRENT_TENANT_CONFIG.moveMarketingRedirectUrl;
